import { useTranslation } from "react-i18next";
import LoadingCard from "./LoadingCard";
import StatsCard from "./StatsCard";

import { FlowStatRecord } from "@dashboard-v3/api";

interface Props {
  loading: boolean;
  currentStats: FlowStatRecord[];
  previousStats: FlowStatRecord[];
}

export default function EmailFlowCard(props: Props) {
  const { t } = useTranslation("usageReports");
  const { loading, currentStats, previousStats } = props;

  if (loading) return <LoadingCard />;

  const previous = previousStats.reduce(toFlowTotals, 0);
  const current = currentStats.reduce(toFlowTotals, 0);

  return (
    <StatsCard
      label={t("emailFlow.title")}
      value={current.toLocaleString()}
      previousAmount={previous}
      currentAmount={current}
    />
  );
}

function toFlowTotals(acc: number, flow: FlowStatRecord) {
  return acc + flow.total;
}
